import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="partner_content">
              <h2>Collab with Reliable Telemedicine App Development Agency</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Select the ideal ally for your telehealth endeavor – a proficient
              team that comprehends your requirements. Our adept telemedicine
              app developers guarantee bespoke solutions, covering
              individualized software crafting, system enhancements, and secure,
              scalable, compliant software engineering.
            </p>
            <p>
              Explore our impressive testimonials, showcasing our dedication to
              perfection as a premier telemedicine development company in the
              United States.
            </p>
          </Col>
        </Row>
        <Row className="h-100 partner_padd">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on Clutch</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">5.0</div>
            <div className="partner-para">
              <p>Average Review Rating on GoodFirms</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on RightFirms</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Partner;
